import { AbiEvent } from 'ox';
import { htlcEvents } from '../abi.js';
import { hex } from '../utils.js';
export function findUserLockedEvent(logs, matchHashlock) {
    for (const log of logs) {
        try {
            const decoded = AbiEvent.decode(htlcEvents.UserLocked, {
                data: hex(log.data),
                topics: log.topics,
            });
            if (!matchHashlock || decoded.hashlock === matchHashlock) {
                return decoded;
            }
        }
        catch {
            // Not a UserLocked event — skip
        }
    }
    return null;
}
export async function waitForReceipt(rpc, txHash, options) {
    const timeout = options?.timeout ?? 120000;
    const interval = options?.interval ?? 2000;
    const start = Date.now();
    while (Date.now() - start < timeout) {
        const receipt = await rpc.getTransactionReceipt(txHash);
        if (receipt) {
            if (receipt.status === '0x0') {
                throw new Error(`Transaction reverted: ${txHash}`);
            }
            return receipt;
        }
        await new Promise(r => setTimeout(r, interval));
    }
    throw new Error(`Transaction receipt timeout after ${timeout}ms: ${txHash}`);
}
